<template>
	<div class="widget-settings-item">
		<v-row no-gutters>
			<v-col cols="auto">
				<div class="label mt-n0">
					<div class="label-text">{{ item.label }}</div>
					<span v-if="item.par" class="pl-1" style="font-size: 12px; color: #919191">{{ item.par }}</span>
				</div>
			</v-col>
			<v-col class="text-right" style="height: 22px">
				<v-switch inset dense v-if="item.canEnable" color="white" hide-details v-model="itemEnabled" class="swtch drk mr-n3 sml">
				</v-switch>
			</v-col>
			<v-col cols="12" class="mt-n1" v-if="item.hasOwnProperty('options')">
				<v-radio-group v-model="itemValue">
					<v-radio
						on-icon="mdi-radiobox-marked"
						off-icon="mdi-radiobox-blank"
						color="#1682D3"
						v-for="option in item.options"
						:key="option.value"
						:value="option.value"
					>
						<template v-slot:label>
							<span class="set_rad_lbl pl-1" style="font-size: 14px; font-weight: 300; color: #354052; top: 3px; position: relative">
								{{ option.label }}
							</span>
						</template>
					</v-radio>
				</v-radio-group>
			</v-col>
		</v-row>
		<div class="description-text" v-if="item.description">{{ item.description }}</div>
		<div v-if="item.editComponent">
			<component v-bind:is="item.editComponent"></component>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'WidgetSettingsItem',
	props: {
		item: { type: Object },
	},
	computed: {
		...mapGetters('widgetEditor', ['widgetMetadata']),
		widgetOptions() {
			return this.widgetMetadata.options || {};
		},
		option: {
			get() {
				return this.widgetOptions[this.item.key] || { active: this.item.default !== 0, value: this.item.default };
			},
			set(value) {
				this.setWidgetOption({ key: this.item.key, value });
			},
		},
		itemEnabled: {
			set(enabled) {
				this.option = Object.assign({}, this.option, { active: enabled });
			},
			get() {
				return this.option.active;
			},
		},
		itemValue: {
			set(value) {
				this.option = Object.assign({}, this.option, { value, active: true });
			},
			get() {
				return this.option.value;
			},
		},
	},
	methods: {
		...mapActions('widgetEditor', ['setWidgetOption']),
	},
};
</script>

<style scoped lang="scss">
.widget-settings-item {
	text-align: left;

	.label {
		font-size: 14px;
		color: #354052;
		font-weight: 500;
	}

	.description-text {
		font-size: 12px;
		color: #919191;
	}
}
.label-text {
	font-size: 12px;
	color: var(--bold-title);
}
</style>
